<style lang="scss">
.page-wrap-inner {
  padding-top: 0 !important;
}
</style>
<template>
  <div>
    <!--=== Header Start ===-->
    <header class="header-navbar sticky-top">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="d-md-flex align-items-center justify-content-between">
              <div class="left-logo">
                <!-- <a href> -->
                <!-- <img src="../assets/Images/capital-group-logo.png" alt="capital group" /> -->
                <img id="imgBanner" v-bind:src="BannerURL" alt="e2m" />
                <!-- </a> -->
              </div>
              <!-- <div class="top-right-login p-3">
                <a
                  v-on:click="goForEventList"
                  class="event-List"
                  data-tag="RegistrationEventList"
                >Event List</a>
                <a v-on:click="goForLogin" class="login" data-tag="goLogin">Login</a>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </header>

    <section
      class="register-page-wrapper body-content"
      style="background-color: #ffffff"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-7">
            <div class="ref-left-hld">
              <h1 class="page-head mb-2">{{ EventsData[0].EventName }}</h1>
              <div class="top-right-login mb-3">
                <!--<a
                  class="event-List"
                >{{EventsData[0].EventStartDate}}&nbsp; to &nbsp;{{EventsData[0].EventEndDate}} &nbsp;{{EventsData[0].EventTimezone}}</a>-->
                <a class="event-List"
                  >{{ EventsData[0].EventStartDateZ }}&nbsp; to &nbsp;{{
                    EventsData[0].EventEndDateZ
                  }}
                  &nbsp;{{ EventsData[0].EventTimezoneZ }}</a
                >
                <!-- <span>{{ date| moment('timezone', 'Asia/Calcutta', 'LLLL')}}</span> -->
                <!-- <span>{{EventsData[0].timeZoneOffset}}</span>
                <span>{{EventsData[0].time}}</span>-->
              </div>
              <!-- <img src="../assets/Images/reg-banner.jpg" alt="e2m" /> -->
              <div class="reg-bnr">
                <img
                  id="imgBannerEvnt"
                  v-bind:src="EventsData[0].EventLogo"
                  alt="e2m"
                />
              </div>
              <p
                v-html="EventsData[0].Description"
                class="p-4 grey-bg my-4"
              ></p>
            </div>
          </div>
          <div v-if="AllowRegistration" class="col-lg-5">
            <div class="top-right-login text-right hdr-btn mb-3 login-ico">
              <!-- <a href class="event-List">Event List</a> -->
              <a v-on:click="goForEventList" class="event-List">Event List</a>
              <!-- <a href class="login">Login</a>goForLogin -->
              <a v-on:click="goForLogin" class="login">Login</a>
            </div>

            <div class="reg-right-hld border p-3 mb-3">
              <h3>Register now</h3>
              <form action="/action_page.php">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Email*"
                        id="txtEmail"
                      />
                      <!-- <input
                        type="text"
                        @blur="checkEmail()"
                        class="form-control"
                        placeholder="Email*"
                        id="txtEmail"
                      />-->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <input
                        required
                        type="text"
                        class="form-control"
                        placeholder="First Name*"
                        id="txtFName"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <input
                        required
                        type="text"
                        class="form-control"
                        placeholder="Last Name*"
                        id="txtLName"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input
                        class="form-control"
                        placeholder="Company (optional)"
                        id="txtCompanyName"
                      />
                    </div>
                  </div>
                  <div class="col-md-12" style="display: none">
                    <div class="form-group">
                      <input
                        class="form-control"
                        placeholder="Title (optional)"
                        id="txtTitle"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <button
                      type="submit"
                      class="reg-button text-uppercase"
                      @click.prevent="UserRegistration()"
                    >
                      Complete Registration
                      <!-- <span class="pl-2">></span> -->
                    </button>
                  </div>

                  <p
                    class="term-amd-c pt-3 text-center px-2 clscheckbox"
                    style="font-size: 14px; width: 100%"
                  >
                    By registering, I Agree to the
                    <a
                      href="https://e2m.live/privacy-policy"
                      style="color: #6287ec"
                      >Privacy Policy</a
                    >
                    and
                    <a
                      href="https://e2m.live/terms-of-use"
                      style="color: rgb(80, 78, 209)"
                      >Terms of Use</a
                    >
                  </p>
                </div>
              </form>
            </div>
            <div class="media border p-3 profile-panel">
              <!-- <img
                src="../assets/Images/reg-banner.jpg"
                alt="John Doe"
                class="mr-3 rounded-circle"
                style="width:60px;height: 60px;"
              />-->
              <span class="mr-3 imageCircle">
                <img id="imgBanner" v-bind:src="clientLogoUrl" alt="e2m" />
              </span>
              <div class="media-body">
                <h6>Hosted By</h6>
                <h5>{{ ClientName }}</h5>
              </div>
              <p v-html="clientProfile" class="mb-0 mt-2"></p>
            </div>
          </div>
          <div v-else class="col-lg-5">
            <div class="top-right-login text-right hdr-btn">
              <!-- <a href class="event-List">Event List</a> -->
              <a v-on:click="goForEventList" class="event-List">Event List</a>
              <!-- <a href class="login">Login</a>goForLogin -->
              <a v-on:click="goForLogin" class="login">Login</a>
            </div>

            <div
              class="reg-right-hld border p-3 mb-3"
              style="min-height: 156px"
            >
              <h3 style="text-align: center">Registration closed.</h3>

              <p style="text-align: center">
                Please contact the event planner.
              </p>

              <form action="/action_page.php"></form>
            </div>
            <div class="media border p-3 profile-panel">
              <!-- <img
                src="../assets/Images/reg-banner.jpg"
                alt="John Doe"
                class="mr-3 rounded-circle"
                style="width:60px;height: 60px;"
              />-->
              <span class="mr-3 imageCircle">
                <img id="imgBanner" v-bind:src="clientLogoUrl" alt="e2m" />
              </span>
              <div class="media-body">
                <h6>Hosted By</h6>
                <h5>{{ ClientName }}</h5>
              </div>
              <p v-html="clientProfile" class="mb-0 mt-2"></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
        display: none;
      "
    >
      <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
      <div class="loader">
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </div>
      <!-- </p> -->
    </div>
    <!-- Success Modal -->
    <div class="modal fade all-modal" id="success-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <span
              class="success-icon d-flex justify-content-center align-items-center"
            >
              <img src="../assets/Images/icons/tick.svg" />
            </span>
            <p>
              <strong>Registration Completed Successfully!</strong>
            </p>
            <p>You will receive a confirmation email with your login link.</p>
            <p>
              <strong>Please save your confirmation email.</strong>
            </p>
            <p>
              If you do not receive the email, please check your spam folder or
              contact event planner.
            </p>
            <p>
              <span data-dismiss="modal" class="btn-pink sussecc-btn"
                >Great!</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Success Modal Ends-->
    <!-- Othe msg  Modal -->
    <div class="modal fade all-modal" id="Othermsg-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg">
              This email is already registered, please sign-up with a different
              email.
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Othe msg  Modal Ends-->
  </div>
</template>
<script>
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
import router from "../router";
var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import APIs from "@/components/APIInit";

Vue.use(VueMoment, {
  moment,
});

export default {
  components: {},
  data() {
    return {
      AllowRegistration: false,
      evntId: "",
      clientID: "", //this.$store.getters.getClient[0].id,
      EventsData: [],
      BannerURL: "",
      clientLogoUrl: "",
      ClientName: "",
      clientProfile: "",
      reg: /^(([^<>()/[\]//.,;:\s@"]+(\.[^<>()/[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      date: moment.tz("2020-06-26 00:00", "Asia/Calcutta"),
    };
  },
  computed: {},
  async mounted() {
    self = this;
    var qUrl = this.$route.query.s;
    if (qUrl != undefined) {
      if (qUrl.length <= 0) {
        router.push({
          path: "/404",
        });
      } else {
        if (qUrl.substring(0, qUrl.indexOf("E")) != undefined) {
          self.clientID = qUrl.substring(0, qUrl.indexOf("E"));
        } else {
          router.push({
            path: "/404",
          });
        }
        if (qUrl.substring(qUrl.indexOf("E"), qUrl.length) != undefined) {
          self.evntId = qUrl.substring(qUrl.indexOf("E"), qUrl.length); //this.$route.params.sid;
        } else {
          router.push({
            path: "/404",
          });
        }
      }
    } else {
      router.push({
        path: "/404",
      });
    }

    self.EventsData = [];
    self.getEventDetails();
    $("#topmenu").hide();
    $("#leftmenu").hide();

    var brandingData;
    try {
      brandingData = await self.getBrandingJSONDetails(
        "OA_UAT_" + qUrl + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        this.item = brandingData.data;

        $(document).attr(
          "title",
          "Registration - " + brandingData.data.ClientInfo.ClientName
        );
        if (brandingData.data.ClientInfo != undefined) {
          self.BannerURL =
            brandingData.data.ClientInfo.EventListAssets.banner2048x88;

          //-------------------FAVICONJOB------------------------------------------------------------

          if (brandingData.data.ClientInfo.Favicon != undefined) {
            if (brandingData.data.ClientInfo.Favicon != "") {
              var link =
                document.querySelector("link[rel*='icon']") ||
                document.createElement("link");
              link.type = "image/x-icon";
              link.rel = "shortcut icon";
              link.href = brandingData.data.ClientInfo.Favicon;
              document.getElementsByTagName("head")[0].appendChild(link);
            }
          }
          //----------------------------------------------------------------------------------
        } else {
          self.BannerURL == "";
        }
        var dateFormat = require("dateformat");

        var obj = new Object();
        debugger;
        obj.eventId = self.evntId;
        obj.EventName = brandingData.data.EventInfo.EventFullName;
        obj.EventTimezone = brandingData.data.EventInfo.TimeZone; // moment.tz.guess();
        obj.EventTimezoneZ = moment.tz.guess();
        obj.EventLogo = brandingData.data.EventInfo.EventLogo;
        obj.Description = brandingData.data.EventInfo.Description;
        self.AllowRegistration = brandingData.data.EventInfo.AllowRegistration;
        obj.EventStartDate = dateFormat(
          brandingData.data.EventInfo.EventStartDate,
          "mmm dd, hh:MM TT"
        );

        obj.EventEndDate = dateFormat(
          brandingData.data.EventInfo.EventEndDate,
          "mmm dd, hh:MM TT"
        );

        obj.EventStartDateZ = self.GetTimeByZone(
          brandingData.data.EventInfo.EventStartDate,
          brandingData.data.EventInfo.TimeZone
        );
        obj.EventStartDateZ = self.GetTimeByZone(
          obj.EventStartDateZ,
          moment.tz.guess()
        );
        obj.EventStartDateZ = dateFormat(
          obj.EventStartDateZ,
          "mmm dd, hh:MM TT"
        );
        obj.EventEndDateZ = self.GetTimeByZone(
          brandingData.data.EventInfo.EventEndDate,
          brandingData.data.EventInfo.TimeZone
        );
        obj.EventEndDateZ = self.GetTimeByZone(
          obj.EventEndDateZ,
          moment.tz.guess()
        );
        obj.EventEndDateZ = dateFormat(obj.EventEndDateZ, "mmm dd, hh:MM TT");
        self.EventsData.push(obj);
        //------------------------------------------------------
        self.ClientName = brandingData.data.HostInfo.Name;
        self.clientLogoUrl = brandingData.data.HostInfo.Logo;
        self.clientProfile = brandingData.data.HostInfo.Profile;
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
      router.push({
        path: "/404",
      });
    }
  },
  methods: {
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MM/DD/YYYY HH:mm");
      return date;
    },
    getEventDetails() {
      /* debugger;
      console.log(self.evntId);
      db.collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events")
        .doc(self.evntId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            var data = doc.data();

            var obj = new Object();
            debugger;
            obj.eventId = doc.id;
            obj.EventName = data.EventFullName;
            obj.EventTimezone = moment.tz.guess();
            obj.EventLogo = data.EventLogo;
            obj.Description = data.Description;
            var dateFormat = require("dateformat");
            var dtstrt = new Date(data.EventStartDate.seconds * 1000);
            obj.EventStartDate = dateFormat(dtstrt, "mmm dd, hh:MM TT");
            var dtend = new Date(data.EventEndDate.seconds * 1000);
            obj.EventEndDate = dateFormat(dtend, "mmm dd, hh:MM TT");
            self.EventsData.push(obj);
          }
        })
        .catch((error) => {
          alert(error);
          // console.log("Error getting documents: ", error);
        });*/
      // console.log("eventsdata" + self.EventsData);
    },
    closeModal: function () {
      $("#Othermsg-modal").modal("show");
    },
    GetActualDateFormat: function (actualDt) {
      var dt = actualDt.split("T");
      var oDt = new Date(dt[0]).toDateString();

      var oTt = dt[1];
      var arrDate = oDt.split(" ");
      var accDate = arrDate[1] + " " + arrDate[2];

      var arrtime = oTt.split(":");
      var accTime = arrtime[0] + ":" + arrtime[1];

      var fullStartDate = accDate + " " + accTime;
      return fullStartDate;
    },
    formatDateTimeZoneWise: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        debugger;

        var hrs = dt.getHours();
        hrs = hrs == 0 ? "00" : hrs;
        if (hrs != "00" && parseInt(hrs) < 10) {
          hrs = "0" + hrs;
        }

        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }

        var mnths = dt.getMonth();
        var accurateMon = mnths + 1;
        if (parseInt(accurateMon) < 10) {
          accurateMon = "0" + accurateMon;
        }

        dateString +=
          dt.getFullYear() +
          "-" +
          accurateMon +
          "-" +
          dt.getDate() +
          " " +
          hrs +
          ":" +
          minutes;

        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    newFunc: function (a) {
      alert(a);
    },
    checkEmail: function () {
      // alert("onblur");
      debugger;
      var email = document.getElementById("txtEmail").value;

      if (email.trim() == "") {
        return false;
      }
      email = email.toLowerCase();
      if (!self.reg.test(email)) {
        document.getElementById("dvOtherMsg").innerText =
          "Wrong email format, please enter proper email.";
        $("#Othermsg-modal").modal("show");

        //alert("Wrong email format, please enter proper email.");
        return false;
      }
      var postData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID.toString(),
          eventId: parseInt(self.evntId.replace("E", "")),
        },
        data: {
          Email: email,
        },
      };
      self.showLoader();
      let headers = {
        "Content-Type": "application/json",
      };
      axios
        .post(APIs.ValidateEventAttendeeReg, JSON.stringify(postData), {
          headers: headers,
        })
        .then((response) => {
          if (response.data.regValidationResult == -20) {
            self.hideLoader();
            document.getElementById("dvOtherMsg").value =
              "This email is already registered, please sign-up with a different email.";
            $("#Othermsg-modal").modal("show");
            // alert(
            //   "This email is already registered, please sign-up with a different email."
            // );
            document.getElementById("txtEmail").value = "";
            document.getElementById("txtFName").value = "";
            document.getElementById("txtLName").value = "";
            document.getElementById("txtCompanyName").value = "";
            document.getElementById("txtTitle").value = "";
            return false;
          } else {
            self.hideLoader();
          }
        })
        .catch((error) => {
          self.hideLoader();
          document.getElementById("dvOtherMsg").value =
            "Error in registration process,please try again later." +
            email +
            " Error:" +
            error;
          $("#Othermsg-modal").modal("show");
        });
    },
    UserRegistration: function () {
      var email = document.getElementById("txtEmail").value;
      var fName = document.getElementById("txtFName").value;
      var lname = document.getElementById("txtLName").value;
      var CompanyName = document.getElementById("txtCompanyName").value;
      var title = document.getElementById("txtTitle").value;
      if (email.trim() == "") {
        document.getElementById("dvOtherMsg").innerText = "Email is mandatory.";
        $("#Othermsg-modal").modal("show");
        document.getElementById("txtEmail").focus();
        return false;
      }

      if (!self.reg.test(email)) {
        document.getElementById("dvOtherMsg").innerText =
          "Wrong email format, please enter proper email.";
        $("#Othermsg-modal").modal("show");
        return false;
      }

      if (fName.trim() == "") {
        document.getElementById("dvOtherMsg").innerText =
          "First Name is mandatory.";
        $("#Othermsg-modal").modal("show");
        document.getElementById("txtFName").focus();
        return false;
      }
      if (lname.trim() == "") {
        document.getElementById("dvOtherMsg").innerText =
          "Last Name is mandatory.";
        $("#Othermsg-modal").modal("show");
        document.getElementById("txtLName").focus();
        return false;
      }
      debugger;
      email = email.toLowerCase();

      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events");

      listRef
        .where("AllowRegistration", "==", true)
        .where("EventTypeId", "==", 2)
        .where("EventId", "==", self.evntId)
        //.get()
        .onSnapshot((querySnapshot) => {
          debugger;
          if (querySnapshot.docs.length > 0) {
            var postData = {
              key: {
                instanceId: "OA_UAT",
                clientId: self.clientID.toString(),
                eventId: parseInt(self.evntId.replace("E", "")),
              },
              data: {
                Email: email,
                FirstName: fName,
                LastName: lname,
                Company: CompanyName,
                Title: title,
              },
            };
            debugger;
            //console.log(postData);
            var hostUrl = location.host.toLowerCase();
            // console.log(hostUrl);
            var apiUrl = "";
            var xAPIkey = "";
            if (hostUrl.includes("localhost")) {
              apiUrl = "https://uat-awsapi.e2m.live/register-event-attendee";
              xAPIkey = "bfrYxacvbh9LPzDooKO9FaftkZBjcDO8q0wTotn9";
            } else {
              if (hostUrl.includes("uat")) {
                apiUrl = "https://uat-awsapi.e2m.live/register-event-attendee";
                xAPIkey = "bfrYxacvbh9LPzDooKO9FaftkZBjcDO8q0wTotn9";
              } else if (hostUrl.includes("stage")) {
                apiUrl =
                  "https://m4r9jvvpfl.execute-api.us-east-1.amazonaws.com/STG/register-event-attendee";
                xAPIkey = "02pCJXJP5D952B7pVfyjU17lFffonkOOsAJUKAKh";
              } else {
                apiUrl = "https://awsapi.e2m.live/register-event-attendee";
                xAPIkey = "8a3VpLztmX9Cy9c6np8jK6eIR5iV6CUS5g1Pu8tj";
              }
            }

            $.ajax({
              url: apiUrl,
              headers: {
                "Content-Type": "application/json",
                "x-api-key": xAPIkey, //"bfrYxacvbh9LPzDooKO9FaftkZBjcDO8q0wTotn9",
              },
              beforeSend: function () {
                self.showLoader();
              },
              type: "POST",
              // mode: 'cors',
              credentials: "include",
              crossDomain: true,
              dataType: "json",
              processData: false,
              data: JSON.stringify(postData),

              success: function (data) {
                self.hideLoader();
                debugger;
                // console.log(data);
                if (data.regStatus == 0) {
                  $("#success-modal").modal("show");

                  // alert(
                  //   "You have successfully registered for the event, please check your Inbox for more info."
                  // );
                  document.getElementById("txtEmail").value = "";
                  document.getElementById("txtFName").value = "";
                  document.getElementById("txtLName").value = "";
                  document.getElementById("txtCompanyName").value = "";
                  document.getElementById("txtTitle").value = "";
                  return false;
                } else if (data.regStatus == -20) {
                  // alert(
                  //   "This email is already registered, please sign-up with a different email."
                  // );
                  document.getElementById("dvOtherMsg").innerText =
                    "This email is already registered, please sign-up with a different email.";
                  $("#Othermsg-modal").modal("show");
                  document.getElementById("txtEmail").value = "";
                  document.getElementById("txtFName").value = "";
                  document.getElementById("txtLName").value = "";
                  document.getElementById("txtCompanyName").value = "";
                  document.getElementById("txtTitle").value = "";
                  return false;
                } else if (data.regStatus == -99) {
                  // alert(
                  //   "An Unknown error has occurred, please try again later."
                  // );
                  document.getElementById("dvOtherMsg").value =
                    "An Unknown error has occurred, please try again later.";
                  $("#Othermsg-modal").modal("show");
                  document.getElementById("txtEmail").value = "";
                  document.getElementById("txtFName").value = "";
                  document.getElementById("txtLName").value = "";
                  document.getElementById("txtCompanyName").value = "";
                  document.getElementById("txtTitle").value = "";
                  return false;
                } else {
                  // alert(
                  //   "An Unknown error has occurred, please try again later."
                  // );
                  document.getElementById("dvOtherMsg").value =
                    "An Unknown error has occurred, please try again later.";
                  $("#Othermsg-modal").modal("show");
                  document.getElementById("txtEmail").value = "";
                  document.getElementById("txtFName").value = "";
                  document.getElementById("txtLName").value = "";
                  document.getElementById("txtCompanyName").value = "";
                  document.getElementById("txtTitle").value = "";
                  return false;
                }
              },
              error: function (xhr, status, error) {
                self.hideLoader();
                // var err = eval("(" + xhr.responseText + ")");
                debugger;
                // alert(
                //   "Error in registration process,please try again later." +
                //     email +
                //     " Error:" +
                //     error
                // );
                document.getElementById("dvOtherMsg").value =
                  "Error in registration process,please try again later." +
                  email +
                  " Error:" +
                  error;
                $("#Othermsg-modal").modal("show");

                document.getElementById("txtEmail").value = "";
                document.getElementById("txtFName").value = "";
                document.getElementById("txtLName").value = "";
                document.getElementById("txtCompanyName").value = "";
                document.getElementById("txtTitle").value = "";
                return false;
              },
            });
            // document.getElementById("txtEmail").value = "";
            // document.getElementById("txtFName").value = "";
            // document.getElementById("txtLName").value = "";
            // document.getElementById("txtCompanyName").value = "";
            // document.getElementById("txtTitle").value = "";
            // return false;
          } else {
            self.hideLoader();
            document.getElementById("dvOtherMsg").innerText =
              "Registration for this event is currently closed, please contact administrator.";
            $("#Othermsg-modal").modal("show");
            return false;
          }
        });
      //----------------------------------------------------------------------------------------------------
      // debugger;
      // if (notEnabledCnt <= 0) {

      // }
    },
    formatDate: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        const monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }

        dateString +=
          dt.getDate() +
          " " +
          monthNamesShort[dt.getMonth()] +
          " " +
          dt.getHours() +
          ":" +
          minutes;
        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    goForEventList: function () {
      //router.push({ name: "EventListReg" });
      router.push({
        path: "/RegEvent",
        query: {
          c: self.clientID,
        },
      });
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
  },
};
</script>

<style>
.reg-bnr {
  border: 1px solid #dee2e6;
  border-radius: 3px;
  overflow: hidden;
}
.register-page-wrapper .profile-panel {
  align-items: center;
}
.profile-panel .imageCircle {
  width: 168px;
  height: 70px;
  border-radius: 5px;
}
.profile-panel .imageCircle img {
  max-height: 100%;
}
.profile-panel > p {
  width: 100%;
}
.top-right-login.hdr-btn {
  padding: 0 0 20px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo {
  width: 100%;
}
</style>
